<template>
  <v-card>
    <v-toolbar style="background-color: #1daf80; color: #fff">
      <v-toolbar-title>
        <span class="headline">Nova Classe</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="container">
        <div class="row">
          <!-- <div class="col-4">
                <v-select
                  v-model="select_orgao"
                  :items="list_orgao"
                  item-text="desc"
                  item-value="id"
                  label="Orgão"
                  hide-details
                />
              </div> -->
          <div class="col-9">
            <v-text-field v-model="descricao" label="Descrição" hide-details />
          </div>
          <div class="col-3">
            <v-switch
              v-model="ativo"
              hide-details
              :label="ativo ? 'Ativo' : 'Inativo'"
            ></v-switch>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-content-between">
      <v-btn color="primary" outlined @click="$emit('close')"> Cancelar </v-btn>
      <v-btn
        color="#1daf80"
        :dark="descricao != ''"
        :disabled="descricao == ''"
        @click="novaClasse()"
      >
        Cadastrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ClassificacaoService from "@/services/classificacao_service.js";
import Mixin from "@/mixins/vuex_mixin.js";

export default {
  mixins: [Mixin],
  props: {},
  components: {},
  data: () => ({
    services: {
      classificacaoService: ClassificacaoService.build(),
    },
    descricao: "",
    ativo: true,
  }),
  watch: {},
  mounted() {},
  computed: {},
  methods: {
    novaClasse() {
      this.services.classificacaoService
        .postCreateClasse(this.model())
        .then(async (response) => {
          const body = await response.json();
          if (response.status == 200) {
            this.$_ACTIONS_showSnackbarMessage({
              message:
                body.message || this.$global.messages.internalServerError,
              color: "sucess",
            });
            this.$emit("response");
          } else {
            this.$_ACTIONS_showSnackbarMessage({
              message:
                body.message || this.$global.messages.internalServerError,
              color: "error",
            });
            console.error(response);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    model() {
      // descricao:jumentobis de pirambas
      // id:5
      // status: 1 true || 2 false
      return {
        descricao: this.descricao,
        status: this.ativo ? 1 : 2,
      };
    },
  },
};
</script>
<style scoped></style>
